import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const comparisonData = [
  { feature: 'Organized Products', acbuy: true, manual: false, icon: 'ri-layout-grid-line' },
  { feature: 'Updated Links Weekly', acbuy: true, manual: false, icon: 'ri-refresh-line' },
  { feature: 'Price Comparison Ready', acbuy: true, manual: false, icon: 'ri-scales-line' },
  { feature: 'Time-Saving Navigation', acbuy: true, manual: false, icon: 'ri-timer-flash-line' },
  { feature: 'Expert Buying Guides', acbuy: true, manual: false, icon: 'ri-book-open-line' },
  { feature: 'Safety & QC Information', acbuy: true, manual: false, icon: 'ri-shield-check-line' },
];

export default function WhySection() {
  return (
    <section id="why" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
          <div className="lg:w-2/5">
            <div className="relative mb-8 rounded-2xl overflow-hidden h-[260px]">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20desk%20with%20laptop%20displaying%20neat%20spreadsheet%20interface%20next%20to%20fashion%20items%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20photography%2C%20clean%20productivity%20composition%2C%20warm%20neutral%20background%2C%20modern%20organized%20workspace%2C%20no%20visible%20screen%20text&width=700&height=500&seq=why-comparison-v2&orientation=landscape"
                alt="ACBuySpreadsheet organized shopping experience"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-3">
              Why ACBuySpreadsheet?
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Thousands Use ACBuySpreadsheet for Smarter Shopping
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
              Unlike searching manually through countless pages, the <strong>acbuy spreadsheet</strong> directory organizes everything in one place. Whether you are hunting for the <strong>best acbuy spreadsheet</strong> categories or need a complete <strong>acbuy spreadsheet guide</strong>, ACBuySpreadsheet delivers the most up-to-date product links and buying resources for 2026.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <Link
                to="/acbuy-spreadsheet-guide"
                className="px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Read the Guide →
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 border-2 border-primary-500 text-primary-600 text-sm font-semibold rounded-full hover:bg-primary-50 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Browse Spreadsheet
              </a>
            </div>
          </div>

          <div className="lg:w-3/5 w-full">
            <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70">
              <div className="grid grid-cols-[1fr_auto_auto] border-b border-background-200/70">
                <div className="p-4 text-sm font-semibold text-foreground-700">Feature</div>
                <div className="p-4 text-sm font-semibold text-primary-600 text-center bg-primary-50/50 min-w-[140px]">
                  ACBuySpreadsheet
                </div>
                <div className="p-4 text-sm font-semibold text-foreground-500 text-center min-w-[120px]">
                  Manual Search
                </div>
              </div>
              {comparisonData.map((row, idx) => (
                <div
                  key={row.feature}
                  className={`grid grid-cols-[1fr_auto_auto] ${
                    idx < comparisonData.length - 1 ? 'border-b border-background-100' : ''
                  }`}
                >
                  <div className="p-3.5 flex items-center gap-3 text-sm text-foreground-800">
                    <div className="w-7 h-7 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0">
                      <i className={`${row.icon} text-primary-500 text-sm`}></i>
                    </div>
                    {row.feature}
                  </div>
                  <div className="p-3.5 flex items-center justify-center bg-primary-50/30 min-w-[140px]">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <div className="p-3.5 flex items-center justify-center min-w-[120px]">
                    <i className="ri-close-line text-foreground-400 text-lg"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}